import { EditOutlined } from "@ant-design/icons";
import { Button, ConfigProvider, Pagination, PaginationProps, Space, Switch, Table, TableColumnsType } from "antd"
import viVN from 'antd/locale/vi_VN';
import { DataTypeGeneralConfiguration } from "..";
import { activeEmailConfig, getInfoEmailConfig, getInfoMessagingProviderConfig, IEmailConfig, IEmailInfo, IGeneralConfiguration, IProvider, updateMessagingProviderConfig } from "../../../../api/generalConfiguration/generalConfigurationApi";
import { useMemo, useState } from "react";
import { dataPagination, getPermissionClass, getUserPermissions } from "../../../../until";
import useThrottle from "../../../../hook/useThrottle";
import useToast from "../../../../hook/useToast";
import { DataAuthType, DataEncryptionType, NO_DATA } from "../../../../services/data";
import ModalCreateEmail from "../Modal/ModalCreateEmail";
import ModalEditEmail from "../Modal/ModalEditEmail";
import { formatNumber } from "../../../../services/mixin";
import { ColDef, ICellRendererParams } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import { NodataTable } from "../../../../components/NoDataTable";
import { useLocation } from "react-router-dom";
import { selectorPermission } from "../../../../store/slices/permissionSlice";
import { useSelector } from "react-redux";

interface PropSMS {
  emailConfig?: IEmailConfig[]
  type: number
  paginationTmp: number
  pagination: { current: number, pageSize: number, total: number }

  setPagination: (current: any) => void
  setPaginationTmp: (value: number) => void
  gListEmailConfig?: (pageNumber?: number, pageSize?: number) => void
}

const EmailGeneralConfiguration: React.FC<PropSMS> = ({
  emailConfig, type, paginationTmp, pagination,

  gListEmailConfig, setPaginationTmp, setPagination
}) => {


  const location = useLocation()
  const permissionSlice = useSelector(selectorPermission)
  const { add, edit, delete: isdelete, upload, download } = getUserPermissions(permissionSlice, location.pathname)
  const columnDefs = useMemo<ColDef<IEmailConfig>[]>(
    () => [
      {
        headerName: 'Hành động',
        width: 160,
        resizable: false,
        lockPosition: true,
        cellRenderer: (params: ICellRendererParams<IEmailConfig>) => {
          const record = params.data;

          if (!record) return null;

          return (
            <Space size="middle">

              <div className="t-switch-block t-switch-block-sm">
                <Switch
                  checked={Boolean(record.status)}
                  onChange={() =>
                    uActiveEmailConfig(Number(record.id))
                  }
                />
              </div>


              <EditOutlined
               
            className={` ${getPermissionClass(edit)} text-sm border-D9D9D9 p-5-px bg-white rounded-2`}
                onClick={() => {
                  gInfoEmailConfig(Number(record.id));
                  setOpenEditEmail(true);
                }}
              />
            </Space>
          );
        },
      },
      {
        headerName: 'Tên',
        field: 'emailName',
        flex: 1,
        resizable: true,
        minWidth: 180,
      },
      {
        headerName: 'Xác thực với',
        field: 'authType',
        flex: 1,
        resizable: true,
        minWidth: 160,
        valueFormatter: (params) => {
          const authType = params.value;

          return authType !== null && authType !== undefined
            ? DataAuthType[authType - 1]?.title || ''
            : '';
        },
      },
      {
        headerName: 'Mã hóa kết nối',
        field: 'encryptionType',
        flex: 1,
        resizable: true,
        minWidth: 170,
        cellClass: 'ag-cell-center',
        valueFormatter: (params) => {
          const encryptionType = params.value;

          return encryptionType !== null && encryptionType !== undefined
            ? DataEncryptionType[encryptionType - 1]?.title || ''
            : '';
        },
      },
      {
        headerName: 'Máy chủ SMTP',
        field: 'smtpHost',
        flex: 1,
        resizable: true,
        minWidth: 180,
        cellClass: 'ag-cell-center',
      },
      {
        headerName: 'Cổng SMTP',
        field: 'smtpPort',
        flex: 1,
        resizable: true,
        minWidth: 130,
        cellClass: 'ag-cell-center',
      },
      {
        headerName: 'Ngày kết nối',
        field: 'dateConnected',
        align: 'center',
        resizable: true,
        minWidth: 130,
        cellRenderer: (params: ICellRendererParams<IEmailConfig>) => {
          const record = params.data;

          if (!record) return null;

          return (
            <span className="">{(record.dateConnected) || NO_DATA}</span>
          );
        },
      },
    ],
    [emailConfig]
  );


  const pushToast = useToast()
  const [openCreateEmail, setOpenCreateEmail] = useState(false)
  const [openEditEmail, setOpenEditEmail] = useState(false)

  const [infoEmailConfig, setInfoEmailConfig] = useState<IEmailInfo>()

  const gInfoEmailConfig = useThrottle(async (id: number) => {
    const result = await getInfoEmailConfig(id)
    if (result?.status) {
      setInfoEmailConfig(result.data)
    } else {
      pushToast(result?.message, "warning")
    }
  }, 1000)

  const uActiveEmailConfig = useThrottle(async (id: number) => {
    const result = await activeEmailConfig(id);
    if (result?.status) {
      gListEmailConfig?.(paginationTmp, pagination.pageSize)
      pushToast(result.message, "success", 2000)
    } else {
      pushToast(result.message, "error", 2000)

    }
  }, 2000)
  const onPaginationChange: PaginationProps['onChange'] = (pageNumber, pageSize) => {
    setPaginationTmp(pageNumber);
    setPagination((prev: any) => ({ ...prev, current: pageNumber, pageSize }))
    gListEmailConfig?.(pageNumber, pageSize)
  }
  return (
    <div className="custom-page-css flex flex-col flex-1 pt-2">
      <ModalCreateEmail
        isOpen={openCreateEmail}
        type={type}
        gListEmailConfig={gListEmailConfig}
        closeModal={() => setOpenCreateEmail(!openCreateEmail)}

      />

      <ModalEditEmail
        isOpen={openEditEmail}
        type={type}
        infoEmailConfig={infoEmailConfig}
        paginationTmp={paginationTmp}
        pagination={pagination}

        gListEmailConfig={gListEmailConfig}
        closeModal={() => setOpenEditEmail(!openEditEmail)}
      />
      {/* <div className="d-flex align-center justify-between pb-4">
        <span className="font-medium fsz-16 lh-24">Thông tin tích hợp</span>
        <button

          className="rounded-6-px h-8 w-83-px text-white bg-1890FF border-none text-sm"
          onClick={() => setOpenCreateEmail(true)}
        >
          Tạo mới
        </button>
      </div> */}

      <div className="d-flex align-center justify-between pb-4">
        <span className="font-medium fsz-16 lh-24">Thông tin tích hợp</span>
        <div className="custom-page-css flex items-center gap-2">
          {/* <Button className=" custom-page-css border rounded px-2"
            onClick={() => setIsModalSupplierManagement(true)}
          >
            <span>Quản lý nhà cung cấp</span>
          </Button> */}
          <Button

            className={` ${getPermissionClass(add)} `}
            type="primary"
            onClick={() => setOpenCreateEmail(true)}
          >
            Tạo mới
          </Button>
        </div>
      </div>

      <div className="custom-page-css flex flex-col flex-1 justify-between">
        <div className="ag-theme-alpine custom-table-ag custom-css-table "
          style={{ width: '100%', height: 650 }}

        >
          <AgGridReact
            // domLayout="autoHeight"
            className="my-auto-height-grid"
            rowData={emailConfig}
            columnDefs={columnDefs}
            rowHeight={55}
            suppressCellFocus
            suppressRowClickSelection
            domLayout="autoHeight"
            defaultColDef={{
              resizable: true
            }}
            overlayNoRowsTemplate={NodataTable}
          />
        </div>
        <ConfigProvider locale={viVN}>
          <div className="pagination-block">
            <Pagination
              showSizeChanger
              current={paginationTmp}
              pageSize={pagination.pageSize}
              total={pagination.total}
              itemRender={(page, type, originalElement) => {
                // Chỉ custom khi là nút số trang
                if (type === 'page') {
                  return <span>{formatNumber(page)}</span>;
                }
                // prev / next / jump-prev / jump-next giữ nguyên
                return originalElement;
              }}
              showTotal={(total) => `Tổng cộng ${dataPagination(pagination.total, pagination.pageSize, paginationTmp).totalPage} trang`}
              className='rs-pagination'
              onChange={onPaginationChange}

            />
          </div>
        </ConfigProvider>
      </div>
    </div>
  )
}
export default EmailGeneralConfiguration
